<template>
    <v-icon v-if="inProductDetails" :class="iconStyle" :style="isOutlined ? 'border: solid 1px' : ''" class="mx-auto appbar-icon-button"> mdi-star-outline </v-icon>
    <v-tooltip v-else v-bind="$attrs" bottom open-on-hover content-class="myprovet-tooltip">
        <template v-slot:activator="{ on, attrs }">
            <v-icon :class="iconStyle" class="appbar-icon-button-small" v-on="on" v-bind="attrs" @click="clicked($event)">mdi-star-outline</v-icon>
        </template>

        <span>{{ text }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },

        isOutlined: {
            type: Boolean,
            default: false,
        },

        inProductDetails: {
            type: Boolean,
            default: false,
        },

        text: {
            type: String,
            required: false, // true if !inProductDetails
        },
    },

    computed: {
        iconStyle() {
            if (this.disabled) {
                return 'btn-bg-color-grey grey-color';
            }

            const outlinedStyle = 'btn-bg-color-dark-yellow white--text';
            const standardStyle = 'btn-bg-color-yellow dark-yellow-color';

            return this.isOutlined ? outlinedStyle : standardStyle;
        },
    },

    methods: {
        clicked(event) {
            this.$emit('click', event);
        },
    },
};
</script>
